function calcColor(a, b, percent) {
  return a + Math.round((b - a) * percent);
}

function toHex(num) {
  num = Math.min(num, 255); // not more than 255
  num = Math.max(num, 0); // not less than 0
  var str = num.toString(16);
  if (str.length < 2) {
    str = "0" + str;
  }
  return str;
}

function parseHex(hex) {
  hex = hex.replace("#", "");
  hex = parseInt(hex, 16);
  var r = hex >> 16;
  var g = (hex >> 8) & 0xff;
  var b = hex & 0xff;
  return { r, g, b };
}

export function gradient(hex1, hex2, percent) {
  const color1 = parseHex(hex1);
  const color2 = parseHex(hex2);

  const red = calcColor(color1.r, color2.r, percent);
  const green = calcColor(color1.g, color2.g, percent);
  const blue = calcColor(color1.b, color2.b, percent);

  const redHex = toHex(red);
  const greenHex = toHex(green);
  const blueHex = toHex(blue);

  return `#${redHex}${greenHex}${blueHex}`;
}



// WEBPACK FOOTER //
// ./src/user/util.js